export const NumberOneIcon = () => {
    return (
        <svg
            width="100"
            height="130"
            viewBox="0 0 100 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M27.4857 130V9.28572L38.0714 20.2429H0V0H51.6286V130H27.4857Z"
                fill="#F3F5F7"
            />
        </svg>
    );
};
